import script from "./Range.vue?vue&type=script&setup=true&lang=js"
export * from "./Range.vue?vue&type=script&setup=true&lang=js"

import "./Range.vue?vue&type=style&index=0&id=3a88f850&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a88f850"]])

export default __exports__